import { ITransaction } from "../../../../../redux/type";
import { LOYALTY_PROGRAM_FIELDS } from "../../../../../redux/fields";
import dateToFormat from "../../../../../../../services/adapters.service/dateToFormat";
import { USER_FIELDS } from "../../../../../../user.entity/redux/fields";

const convertMyTransactions = (props: any): ITransaction[] => {
	const data = props?.data || [];

	return (
		data?.map((transaction: any) => ({
			[LOYALTY_PROGRAM_FIELDS.TRANSACTION_ID]:
				transaction[LOYALTY_PROGRAM_FIELDS.TRANSACTION_ID] || 0,
			[LOYALTY_PROGRAM_FIELDS.AMOUNT]:
				transaction[LOYALTY_PROGRAM_FIELDS.AMOUNT] || 0,
			[LOYALTY_PROGRAM_FIELDS.DATE]:
				transaction[LOYALTY_PROGRAM_FIELDS.CREATED_AT] || "",
			[LOYALTY_PROGRAM_FIELDS.DATE_FORMATTED]:
				dateToFormat(transaction[LOYALTY_PROGRAM_FIELDS.CREATED_AT]) || "",
			[LOYALTY_PROGRAM_FIELDS.STATUS]:
				transaction[LOYALTY_PROGRAM_FIELDS.STATUS] || "",
			[LOYALTY_PROGRAM_FIELDS.TYPE]:
				transaction[LOYALTY_PROGRAM_FIELDS.TYPE] || null,
			[LOYALTY_PROGRAM_FIELDS.DESCRIPTION]:
				transaction[LOYALTY_PROGRAM_FIELDS.DESCRIPTION] || null,
			[LOYALTY_PROGRAM_FIELDS.EXPIRED_AT]:
				transaction[LOYALTY_PROGRAM_FIELDS.EXPIRED_AT] || null,
			[LOYALTY_PROGRAM_FIELDS.EXPIRED_AT_FORMATTED]:
				dateToFormat(transaction[LOYALTY_PROGRAM_FIELDS.EXPIRED_AT]) || null,
			[LOYALTY_PROGRAM_FIELDS.CONTEXT]: transaction[
				LOYALTY_PROGRAM_FIELDS.CONTEXT
			]
				? {
						[LOYALTY_PROGRAM_FIELDS.CONTEXT_TYPE]:
							transaction[LOYALTY_PROGRAM_FIELDS.CONTEXT]?.[
								LOYALTY_PROGRAM_FIELDS.CONTEXT_TYPE
							] || null,
						[LOYALTY_PROGRAM_FIELDS.CONTEXT_DESCRIPTION]:
							transaction[LOYALTY_PROGRAM_FIELDS.CONTEXT]?.[
								LOYALTY_PROGRAM_FIELDS.CONTEXT_DESCRIPTION
							] || null,
						[LOYALTY_PROGRAM_FIELDS.CONTEXT_ID]:
							transaction[LOYALTY_PROGRAM_FIELDS.CONTEXT]?.[
								LOYALTY_PROGRAM_FIELDS.CONTEXT_ID
							] || null,
						[LOYALTY_PROGRAM_FIELDS.AUTHOR]: transaction[
							LOYALTY_PROGRAM_FIELDS.CONTEXT
						]?.[LOYALTY_PROGRAM_FIELDS.AUTHOR]
							? {
									[LOYALTY_PROGRAM_FIELDS.ID]:
										transaction[LOYALTY_PROGRAM_FIELDS.CONTEXT]?.[
											LOYALTY_PROGRAM_FIELDS.AUTHOR
										]?.[USER_FIELDS.ID] || null,
									[USER_FIELDS.FULL_NAME]:
										transaction[LOYALTY_PROGRAM_FIELDS.CONTEXT]?.[
											LOYALTY_PROGRAM_FIELDS.AUTHOR
										]?.[USER_FIELDS.FULL_NAME] || null,
									[LOYALTY_PROGRAM_FIELDS.EMAIL]:
										transaction[LOYALTY_PROGRAM_FIELDS.CONTEXT]?.[
											LOYALTY_PROGRAM_FIELDS.AUTHOR
										]?.[USER_FIELDS.EMAIL] || null,
							  }
							: null,
						[LOYALTY_PROGRAM_FIELDS.PURCHASE]: transaction[
							LOYALTY_PROGRAM_FIELDS.CONTEXT
						]?.[LOYALTY_PROGRAM_FIELDS.PURCHASE]
							? {
									[LOYALTY_PROGRAM_FIELDS.ID]:
										transaction[LOYALTY_PROGRAM_FIELDS.CONTEXT]?.[
											LOYALTY_PROGRAM_FIELDS.PURCHASE
										]?.[LOYALTY_PROGRAM_FIELDS.ID] || null,
									[LOYALTY_PROGRAM_FIELDS.NAME]:
										transaction[LOYALTY_PROGRAM_FIELDS.CONTEXT]?.[
											LOYALTY_PROGRAM_FIELDS.PURCHASE
										]?.[LOYALTY_PROGRAM_FIELDS.NAME] || null,
									[LOYALTY_PROGRAM_FIELDS.PRICE]:
										transaction[LOYALTY_PROGRAM_FIELDS.CONTEXT]?.[
											LOYALTY_PROGRAM_FIELDS.PURCHASE
										]?.[LOYALTY_PROGRAM_FIELDS.PRICE] || null,
									[LOYALTY_PROGRAM_FIELDS.CASHBACK]:
										transaction[LOYALTY_PROGRAM_FIELDS.CONTEXT]?.[
											LOYALTY_PROGRAM_FIELDS.PURCHASE
										]?.[LOYALTY_PROGRAM_FIELDS.CASHBACK] || null,
							  }
							: null,
				  }
				: null,
		})) || []
	);
};

export default convertMyTransactions;
